// lodash components
import startsWith from 'lodash/startsWith'
import map from 'lodash/map'
import filter from 'lodash/filter'
import _set from 'lodash/set'
import sortBy from 'lodash/sortBy'

class AbiDataFiller {
    constructor(newData, i18n, store) {
        this.newData = newData
        this.i18n = i18n
        this.store = store
        this.destinationMessages = i18n.global.messages[i18n.global.locale]

        this.fillStandardOptions()
        this.fillSpecialCaseOptions()
    }

    fillStandardOptions() {
        const loanPurposes = this.mapOptions('loan_purposes', 'form.fields.loanPurpose.options')
        this.store.state.global.mappings.loanPurposes = sortBy(loanPurposes, ({ name }) => (name === 'Other' ? 1 : 0))

        this.mapOptions('banks', 'form.fields.nameOfBank.options')
        this.mapOptions('countries', 'form.fields.countryOfBirth.options')
        this.mapOptions('education_levels', 'form.fields.education.options')
        this.mapOptions('employment_statuses', 'form.fields.employmentStatus.options')
        this.mapOptions('marital_statuses', 'form.fields.maritalStatus.options')
        this.mapOptions('pay_frequencies', 'form.fields.employmentPayment.options')
        this.mapOptions('resident_types', 'form.fields.currentAddressResidenceType.options')
        this.mapOptions('job_titles', 'form.fields.jobTitle.options')
        this.mapOptions('titles', 'form.fields.title.options')
        this.mapOptions('address_durations', 'form.fields.currentAddressDuration.options')
        this.mapOptions('address_durations', 'form.fields.previousAddressDuration.options')
        this.mapOptions('employment_durations', 'form.fields.employmentDuration.options')
        this.mapOptions('card_types', 'form.fields.cardType.options')
        this.mapOptions('credit_ratings', 'form.fields.creditRatings.options')
        this.mapOptions('states', 'form.fields.states.options')
    }

    fillSpecialCaseOptions() {
        if (this.newData.employment_industries) {
            let itemId = ''

            const allOptions = filter(this.newData.employment_industries, item => !startsWith(item.name, 'Inne'))
            const otherOptions = filter(this.newData.employment_industries, item => startsWith(item.name, 'Inne'))

            const employmentIndustries = map([...allOptions, ...otherOptions], item => {
                if (process.env.TERRITORY === 'gbr') {
                    itemId = item.name
                } else {
                    itemId = parseInt(item.code) || parseInt(item.id)
                }

                return {
                    id: item.id,
                    value: itemId,
                    name: item.name,
                }
            })

            _set(this.destinationMessages, 'form.fields.employmentIndustry.options', employmentIndustries)
        }
    }

    mapOptions(newDataProp, destinationProp) {
        if (this.newData.hasOwnProperty(newDataProp)) {
            const options = map(this.newData[newDataProp], option => {
                return {
                    value: newDataProp === 'states' ? option.code : parseInt(option.code) || parseInt(option.id),
                    name: option.name,
                }
            })

            _set(this.destinationMessages, destinationProp, options)

            return options
        }

        return null
    }
}

export { AbiDataFiller }
